/** L’APK Android n’apporte un plus que hors iPhone/iPad (push écran éteint). */

export function isIosUserAgent(ua: string): boolean {
  if (/iPhone|iPod/i.test(ua)) return true;
  if (/iPad/i.test(ua)) return true;
  return false;
}

export function isAndroidUserAgent(ua: string): boolean {
  return /Android/i.test(ua);
}

/** True = montrer le guide d’install APK (Android, ou ordinateur pour installer ensuite sur Android). */
export function nativeApkInstallAddsValue(ua: string): boolean {
  if (!ua.trim()) return false;
  return !isIosUserAgent(ua);
}
